import React from "react";
import type { FC } from "react";

import { Button } from "../../../Button";

import type { VibeButtonProps } from "../../types";

const VIBE_SECONDARY_BUTTON_TEST_ID = "vibe-secondary-button-test-id";

export const VibeSecondaryButton: FC<VibeButtonProps> = ({
    view = "secondary",
    customColorsStyles,
    "data-tsid": tsid = VIBE_SECONDARY_BUTTON_TEST_ID,
    ...otherProps
}) => {
    const buttonProps = (() => {
        if (view !== "custom") {
            return {
                ...otherProps,
                view,
            };
        }

        return {
            ...otherProps,
            view,
            customColorsStyles: customColorsStyles!,
        };
    })();

    return <Button data-tsid={tsid} {...buttonProps} />;
};

VibeSecondaryButton.displayName = "Vibe.SecondaryButton";

export default VibeSecondaryButton;
